const modalIndex = (state = 0, action) => {
    switch(action.type) {
        case 'modalIndex':
            return action.payload;
        default:
            return state;
    }
}

export default  modalIndex;